export default __webpack_public_path__ + "static/media/results3.20498194.png";